// google-geocoding.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GoogleGeocodingService {

  constructor() { }

  async getAddressComponents(address: any) {
    return new Promise((resolve, reject) => {
      // geocoder.geocode({ 'address': address }, (results, status) => {
        if (address) {
            const components = address;
            let city = '';
            let state = '';
            let country = '';
            for (const component of components) {
              if (component.types.includes('locality')) {
                city = component.long_name;
              }
              if (component.types.includes('administrative_area_level_1')) {
                state = component.long_name;
              }
              if (component.types.includes('country')) {
                country = component.long_name;
              }
            }
            resolve({ city, state, country });
        } else {
          reject('Geocoder failed due to: ' + status);
        }
      // });
    });
  }
}
